// Static site-wide content for Soul Sync Healing
// Centralised so contact info is editable in one place.

export const SITE = {
    brand: "Soul Sync Healing",
    tagline: "A Safe Space for Emotional & Spiritual Healing",
    email: "shreya@soulsynchealing.info",
    whatsappDisplay: "+91 96437 11055",
    whatsappRaw: "919643711055",
    instagramHandle: "@Shreya.soulsync",
    instagramUrl: "https://instagram.com/Shreya.soulsync",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1714636608872-048fc9231892?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHdhcm0lMjBiZWlnZSUyMG1pbmltYWwlMjB0ZXh0dXJlfGVufDB8fHx8MTc3ODMwMzgyMnww&ixlib=rb-4.1.0&q=85",
    shreya: "https://customer-assets.emergentagent.com/job_soul-sync-healing/artifacts/5wqhnlx0_Untitled%20design.PNG",
    calmNature:
        "https://images.unsplash.com/photo-1769238507012-0c98e68582a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxjYWxtJTIwd2VsbG5lc3MlMjBuYXR1cmV8ZW58MHx8fHwxNzc4MzAzODE3fDA&ixlib=rb-4.1.0&q=85",
    soundHealing:
        "https://images.unsplash.com/photo-1564513290352-53b18ee0c797?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzb3VuZCUyMGhlYWxpbmclMjBib3dsc3xlbnwwfHx8fDE3NzgzMDM4MTd8MA&ixlib=rb-4.1.0&q=85",
    corporate:
        "https://images.unsplash.com/photo-1664382953481-141e97ad9825?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjB3ZWxsbmVzcyUyMHdvcmtzaG9wfGVufDB8fHx8MTc3ODMwMzgxN3ww&ixlib=rb-4.1.0&q=85",
    tarot: "https://images.unsplash.com/photo-1761706280230-e2a1067451f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHx0YXJvdCUyMGNhcmRzJTIwcmVhZGluZ3xlbnwwfHx8fDE3NzgzMDM4MjJ8MA&ixlib=rb-4.1.0&q=85",
    abstractTexture:
        "https://images.unsplash.com/photo-1646600950096-0489e2a461cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHdhcm0lMjBiZWlnZSUyMG1pbmltYWwlMjB0ZXh0dXJlfGVufDB8fHx8MTc3ODMwMzgyMnww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
    {
        slug: "clinical-hypnotherapy",
        name: "Clinical Hypnotherapy",
        icon: "Sparkles",
        short: "Subconscious healing for emotional blocks, fears, anxiety, and inner child wounds.",
        helps: [
            "Anxiety, fear, and overwhelm",
            "Emotional blocks & limiting patterns",
            "Trauma responses",
            "Inner child healing",
            "Confidence and self-trust",
            "Behavioural transformation",
        ],
        process:
            "Each session begins with a gentle intake conversation, followed by a guided trance state where we access the subconscious to gently rework patterns, soothe the nervous system, and integrate new insights.",
        duration: "75–90 minutes",
        availability: "Online sessions available worldwide",
    },
    {
        slug: "family-constellation",
        name: "Family Constellation Therapy",
        icon: "Users",
        short: "Heal generational and ancestral emotional patterns impacting your relationships and self-worth.",
        helps: [
            "Relationship dynamics",
            "Generational trauma",
            "Emotional entanglements",
            "Self-worth & belonging",
            "Patterns repeating across life areas",
        ],
        process:
            "Through systemic mapping and gentle inquiry, we surface hidden loyalties and ancestral knots. The work is slow, reverent, and quietly transformative.",
        duration: "90 minutes",
        availability: "Online or in-person",
    },
    {
        slug: "breathwork",
        name: "Breathwork Sessions",
        icon: "Wind",
        short: "Conscious breath practices for emotional release, nervous system regulation, and embodiment.",
        helps: [
            "Emotional release",
            "Nervous system healing",
            "Stress & anxiety",
            "Embodiment & presence",
            "Trauma release",
        ],
        process:
            "Guided rounds of conscious connected breathing held in a safe container, followed by integration and reflection.",
        duration: "60–75 minutes",
        availability: "Online or in-person",
    },
    {
        slug: "soul-contract-reading",
        name: "Soul Contract Reading",
        icon: "BookOpen",
        short: "Intuitive guidance into karmic lessons, soul themes, and your life path.",
        helps: [
            "Life purpose",
            "Soul lessons",
            "Recurring emotional themes",
            "Spiritual growth",
        ],
        process:
            "An intuitive reading where we explore the threads of your soul story — the lessons, the gifts, and the path forward.",
        duration: "60 minutes",
        availability: "Online sessions available",
    },
    {
        slug: "tarot-guidance",
        name: "Tarot Guidance",
        icon: "Layers",
        short: "Intuitive tarot for emotional clarity, self-reflection, and inner direction.",
        helps: [
            "Emotional insight",
            "Decision clarity",
            "Relationship reflection",
            "Inner direction",
        ],
        process:
            "A reflective tarot conversation, used as a mirror for what is moving within you — never prescriptive, always illuminating.",
        duration: "45–60 minutes",
        availability: "Online sessions available",
    },
    {
        slug: "sound-healing",
        name: "Sound Healing",
        icon: "Music",
        short: "Vibrational healing with sound bowls for deep relaxation and energetic balance.",
        helps: [
            "Deep relaxation",
            "Energetic balance",
            "Stress release",
            "Meditative restoration",
        ],
        process:
            "A grounding sound journey using singing bowls and vibrational instruments, designed to gently reset your nervous system.",
        duration: "45–60 minutes",
        availability: "Online or in-person",
    },
];

// Bookable paid offerings — rendered on Home, Services & Packages pages and
// selectable in the booking form. Prices are charged via Razorpay; the
// server-side catalogue in backend/server.py is the source of truth.
export const BOOKABLE_SERVICES = [
    {
        slug: "pre-talk",
        name: "30-Minute Pre-Talk",
        eyebrow: "Begin Here",
        priceLabel: "₹555",
        duration: "30 minutes · Online",
        short: "A gentle first conversation with Shreya — share what's bringing you in, ask anything you're holding, and feel whether this space is right for you.",
        description:
            "A gentle, no-pressure first conversation with Shreya. This is where you share what's bringing you in, ask anything you're curious or unsure about, and feel whether this space — and this work — is right for you before beginning deeper sessions.",
        includes: [
            "A safe, confidential space to share your story",
            "Honest guidance on which path would serve you best",
            "Answers to anything you're curious or unsure about",
            "Clarity before commitment — zero pressure",
        ],
        idealFor:
            "Anyone curious about hypnotherapy or psycho-spiritual healing who wants to feel the space before stepping in.",
    },
    {
        slug: "one-on-one-hypnotherapy",
        name: "One-on-One Hypnotherapy",
        eyebrow: "Single Session",
        priceLabel: "₹3,000",
        duration: "75–90 minutes · Online",
        short: "A private clinical hypnotherapy session — gently accessing the subconscious to release emotional blocks, soothe anxiety, and rewrite old patterns.",
        description:
            "A private, one-on-one clinical hypnotherapy session with Shreya. Beginning with a gentle intake conversation, we move into a guided trance state where the subconscious can safely release emotional blocks, soothe anxiety, and rework the patterns that keep you stuck.",
        includes: [
            "Gentle intake conversation",
            "Guided clinical hypnotherapy",
            "Subconscious pattern release",
            "Nervous system settling",
            "Integration and after-care guidance",
        ],
        idealFor:
            "Those carrying anxiety, fears, emotional blocks, or inner child wounds who are ready for deep, focused one-on-one work.",
    },
    {
        slug: "personalized-8-session",
        name: "8-Session Personalized Program",
        eyebrow: "Signature Container",
        priceLabel: "₹20,000",
        valueLabel: "Value ₹24,000",
        savingsLabel: "You save ₹4,000",
        duration: "8 one-on-one sessions · Online",
        short: "A deeply personalised healing container — eight one-on-one sessions fully tailored to your story, at a pace that feels safe.",
    },
];

// The Shop — creative & therapeutic products. Structured for scale:
// add categories and products here as the shop grows. No checkout yet —
// products collect early interest only.
export const SHOP = {
    categories: [
        {
            slug: "journals",
            name: "Journals",
            tagline:
                "Guided creative journaling — where reflection becomes something you can hold.",
        },
    ],
    products: [
        {
            slug: "manifestation-journal",
            category: "journals",
            name: "Manifestation Journal",
            status: "Launching November 2026",
            tagline:
                "A journal for turning your inner world into something tangible.",
            description:
                "A guided creative journaling experience combining reflection, intention-setting, visualization and artistic expression.",
            launchNote:
                "I'm creating the first batch based on early interest, so join the list if you'd like to be among the first to know when pre-orders open.",
            coverImage: "/shop/manifestation-journal-cover.png",
            stickerImage: "/shop/journal-sticker-sheets.png",
            pillars: [
                "Reflection",
                "Intention-setting",
                "Visualization",
                "Artistic expression",
            ],
            options: [
                { id: "journal", label: "Journal", priceLabel: "₹749" },
                {
                    id: "journal_stickers",
                    label: "Journal + Sticker Pack",
                    priceLabel: "₹849",
                },
                { id: "not_sure", label: "Not sure yet", priceLabel: null },
            ],
        },
    ],
};

export const PACKAGES = [
    {
        slug: "feminine-healing",
        name: "Feminine Healing & Self-Worth Program",
        eyebrow: "For Women",
        description:
            "A tender container for restoring feminine energy, rebuilding self-worth, and softening into your truest self.",
        includes: [
            "Emotional healing",
            "Feminine energy restoration",
            "Self-worth rebuilding",
            "Relationship pattern work",
            "Identity & embodiment",
            "Emotional resilience",
        ],
        idealFor:
            "Women returning home to themselves and reclaiming their inner ground.",
    },
];

// Signature multi-week / multi-session journeys (rendered as full sections on /packages)
export const PERSONALIZED_JOURNEY = {
    slug: "personalized-8-session",
    eyebrow: "One-on-One Container",
    name: "An 8-Session Personalized Healing Journey",
    intro: "A deeply personalised coaching experience for women ready to heal from toxic relationship patterns, emotional dependency, and attachment wounds — and to create healthier, more fulfilling relationships.",
    intro2: "Unlike a group program, every session is tailored to your unique story, challenges, and healing journey. We work at a pace that feels safe, compassionate, and aligned with your needs.",
    price: 20000,
    priceLabel: "₹20,000",
    valueLabel: "Value ₹24,000",
    savingsLabel: "You save ₹4,000",
    priceCaption: "Value ₹24,000 · You save ₹4,000",
    sessions: [
        {
            n: "01",
            title: "Your Relationship Blueprint",
            items: [
                "Understanding your relationship history",
                "Identifying recurring patterns",
                "Attachment style assessment",
                "Clarifying your healing goals",
            ],
        },
        {
            n: "02",
            title: "Understanding Your Emotional Patterns",
            items: [
                "Trauma bonds and emotional dependency",
                "Triggers and emotional responses",
                "Awareness of unconscious relationship dynamics",
            ],
        },
        {
            n: "03",
            title: "Healing the Inner Child",
            items: [
                "Childhood attachment wounds",
                "Unmet emotional needs",
                "Releasing limiting beliefs",
                "Building self-compassion",
            ],
        },
        {
            n: "04",
            title: "Nervous System Healing",
            items: [
                "Understanding your stress responses",
                "Emotional regulation tools",
                "Breathwork and somatic practices",
                "Creating a sense of inner safety",
            ],
        },
        {
            n: "05",
            title: "Rebuilding Self-Worth",
            items: [
                "Healing self-abandonment",
                "Strengthening confidence",
                "Self-love and self-trust",
                "Reconnecting with your authentic self",
            ],
        },
        {
            n: "06",
            title: "Boundaries & Healthy Communication",
            items: [
                "Setting healthy boundaries",
                "Expressing needs confidently",
                "Letting go of people-pleasing",
                "Developing secure communication",
            ],
        },
        {
            n: "07",
            title: "Creating Healthy Intimacy",
            items: [
                "Secure attachment",
                "Healthy relationship dynamics",
                "Trust, vulnerability, and emotional intimacy",
                "Redefining your relationship standards",
            ],
        },
        {
            n: "08",
            title: "Integration & Moving Forward",
            items: [
                "Reviewing your transformation",
                "Creating your personal healing roadmap",
                "Relapse prevention and future growth",
                "Celebrating your progress",
            ],
        },
    ],
    modalitiesIntro:
        "Depending on your individual needs, sessions may include:",
    modalities: [
        "Psychology-informed coaching",
        "Clinical hypnotherapy",
        "Conscious Connected Breathwork",
        "Somatic practices",
        "Expressive arts",
        "Guided visualisations",
        "Mindfulness and meditation",
        "Reflective journaling",
    ],
    forYouIf: [
        "You feel emotionally stuck in a relationship that no longer feels healthy.",
        "You have left a relationship but still struggle to let go emotionally.",
        "You keep repeating similar relationship patterns.",
        "You find it difficult to set boundaries or trust yourself.",
        "You want to build secure, conscious, and fulfilling relationships.",
    ],
    investment:
        "8 personalised sessions conducted online, along with guided practices, reflection exercises, and ongoing support between sessions.",
};

export const WHO_THIS_IS_FOR = [
    "You feel emotionally overwhelmed and quietly exhausted.",
    "You feel disconnected from yourself and your body.",
    "You're healing from emotional pain, heartbreak, or trauma.",
    "You long for deeper self-understanding.",
    "You struggle with self-worth or quiet self-doubt.",
    "You want emotional and spiritual growth.",
    "You're seeking a holistic, integrative approach to healing.",
];

export const CORPORATE_TOPICS = [
    "Stress & Burnout Management",
    "Emotional Wellness at Workplace",
    "Nervous System Regulation",
    "Mindfulness & Breathwork",
    "Women's Emotional Wellness",
    "Work–Life Balance",
    "Emotional Resilience",
    "Mental Wellness Circles",
    "Conscious Leadership",
];

export const BLOG_POSTS = [
    {
        slug: "breathwork-and-the-nervous-system",
        title: "Breathwork and the Nervous System: How the Breath Brings You Back to Safety",
        excerpt:
            "How conscious breathwork calms a dysregulated nervous system, why insight alone isn't enough, and a simple practice to return to safety in your body.",
        metaDescription:
            "How conscious breathwork calms a dysregulated nervous system, why insight alone isn't enough, and a simple practice to return to safety in your body.",
        category: "Nervous System",
        readTime: "6 min read",
        date: "May 9, 2026",
        image: "https://images.unsplash.com/photo-1769238507012-0c98e68582a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxjYWxtJTIwd2VsbG5lc3MlMjBuYXR1cmV8ZW58MHx8fHwxNzc4MzAzODE3fDA&ixlib=rb-4.1.0&q=85",
        body: [
            { type: "p", text: "For a long time I believed that if I could just understand why I felt the way I did, the feeling would loosen its grip. I read, I reflected, I named my patterns. And still, my body stayed braced." },
            { type: "p", text: "That's the thing most of us aren't told: insight doesn't always reach the nervous system. You can know you're safe and still feel the opposite, because the body keeps its own record. It holds what the mind has already filed away." },
            { type: "h2", text: "Why the body stays on guard" },
            { type: "p", text: "When we live through stress, grief, or anything that asks too much of us too fast, the nervous system learns to stay ready. Shoulders that won't drop. A breath that never quite reaches the bottom of the lungs. A low hum of alertness that follows you into rooms where nothing is wrong. This isn't a flaw. It's protection that forgot to switch off. And you can't think your way out of it, because the part of you holding the tension doesn't speak in words." },
            { type: "h2", text: "Where the breath comes in" },
            { type: "p", text: "The breath is the one part of this system you can reach on purpose. It runs automatically, yet you can also take it in your hands and slow it down. That's what makes it such a tender doorway." },
            { type: "p", text: "When you lengthen the exhale, you send a quiet message along the vagus nerve: we are safe now. The heart rate softens. The body begins to believe what the mind has been trying to tell it. Done with care and over time, conscious breathwork doesn't just relax you in the moment. It widens the window in which you can feel calm at all." },
            { type: "h2", text: "A small practice to try" },
            { type: "p", text: "You don't need anything for this. Sit, or lie down. Breathe in gently through the nose for a count of four. Let the out-breath be longer than the in-breath, slow and unforced, for a count of six. Do this for two or three minutes and notice, without judging, what shifts. Often it's small. A sigh. A loosening behind the eyes. That's the nervous system beginning to trust the moment." },
            { type: "p", text: "This is the gentle end of the work. There's a deeper, fuller practice too, one held in a safe container with a trained facilitator, where the breath can move what words never could." },
            { type: "h2", text: "Where I learned to hold this" },
            { type: "p", html: "I didn't come to breathwork as a technique. I came to it as someone who needed it. I trained as a facilitator through the <a href=\"https://sensessrilanka.com/breathwork-teacher-training-sri-lanka/\" target=\"_blank\" rel=\"noopener\" class=\"underline decoration-[#A68A6B] underline-offset-4 hover:text-[#A68A6B] transition-colors\">breathwork teacher training with Senses in Sri Lanka</a>, on a quiet fruit farm on the south coast, and it changed how I understand healing entirely. It taught me that the body isn't a problem to solve, but a place to come home to." },
            { type: "p", text: "So much of what I offer now grew from that ground. If the breath is calling you, listen gently. It usually knows the way before the rest of you does." },
        ],
    },
    {
        slug: "what-is-psycho-spiritual-healing",
        title: "What is Psycho-Spiritual Healing?",
        excerpt:
            "A gentle introduction to the bridge between modern psychology and soul-rooted healing — and why integrating both changes everything.",
        category: "Psycho-Spiritual",
        readTime: "6 min read",
        date: "March 12, 2025",
        body: [
            "Psycho-spiritual healing is the quiet meeting point between two truths: that we are wired for psychology — patterns, beliefs, nervous system responses — and that we are also more than our biography.",
            "When healing addresses only the mind, the soul stays restless. When healing addresses only the spirit, the body stays unintegrated. Psycho-spiritual healing weaves both — therapy that honours science, and soul work that honours mystery.",
            "In practice, this means using clinical tools like hypnotherapy, breathwork, and emotional processing alongside intuitive work like soul contract reading, tarot reflection, and inner child journeys. The result is healing that doesn't just shift behaviour — it shifts identity, relationship, and direction.",
            "If you've felt that traditional therapy reached a ceiling, or that purely spiritual work bypassed your real wounds, this integrative path might be the one your system has been quietly asking for.",
        ],
    },
    {
        slug: "inner-child-healing-gentle-guide",
        title: "Inner Child Healing: A Gentle Guide",
        excerpt:
            "Why the soft, younger parts of you still shape your adult relationships — and how to begin tending to them.",
        category: "Inner Child",
        readTime: "8 min read",
        date: "February 24, 2025",
        body: [
            "Inner child healing is not about blaming the past. It's about acknowledging that the parts of you that didn't get to feel safe, seen, or held are still inside you — quietly running the show.",
            "These younger parts often surface as overreactions, sudden shutdown, perfectionism, or relationship loops that feel familiar but painful. They are not flaws. They are messengers.",
            "In a healing session, we slow down enough to meet these parts with curiosity instead of judgement. We listen. We re-parent. We create the safety they didn't get the first time.",
            "Healing your inner child is one of the most quietly radical things you can do — because the way you treat that part of you eventually becomes the way you treat everyone you love.",
        ],
    },
    {
        slug: "nervous-system-healing",
        title: "Why Nervous System Healing is the Foundation",
        excerpt:
            "Insight is not enough if your body still feels unsafe. A look at the somatic root of emotional healing.",
        category: "Nervous System",
        readTime: "5 min read",
        date: "January 30, 2025",
        body: [
            "You can know exactly why you feel anxious and still feel anxious. That gap is where nervous system healing lives.",
            "When the body has lived in chronic activation or shutdown, the mind's clarity isn't enough to land. Healing has to include the body — its breath, its tension, its rhythm.",
            "Breathwork, somatic awareness, and gentle hypnotherapy give the body the message it has been waiting for: it's safe to soften now.",
            "This is the often-skipped foundation. Without it, every other layer of healing struggles to take root.",
        ],
    },
    {
        slug: "feminine-wellness-self-worth",
        title: "Feminine Wellness & The Quiet Return to Self-Worth",
        excerpt:
            "Reclaiming softness, slowness, and self-worth in a world that taught you to perform.",
        category: "Feminine Wellness",
        readTime: "7 min read",
        date: "January 8, 2025",
        body: [
            "Feminine wellness isn't about aesthetics. It's about coming home to a self that was always worthy — long before you proved anything.",
            "Many women arrive in healing exhausted from over-functioning, over-giving, and over-shrinking. The work is not about adding more. It's about returning.",
            "Self-worth is rebuilt slowly: through nervous system care, boundary-setting, ancestral pattern work, and learning to trust your own knowing.",
            "Healing is allowed to feel soft. In fact, the softness is often the medicine.",
        ],
    },
];
